module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/changing_ukedo-283adda2fdbacf61179d2e8b7216f6ae.jpg";